import React from 'react'
import PropTypes from 'prop-types'
import { IMaskInput } from 'react-imask'
import axios from 'axios'

// Импортируем SVG как компоненты (в реальном проекте это были бы отдельные файлы)
const PhoneIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5624 12.9838C15.5624 13.2388 15.5057 13.5009 15.3853 13.7559C15.2649 14.0109 15.1091 14.2517 14.9037 14.4784C14.5566 14.8609 14.1741 15.1372 13.742 15.3142C13.317 15.4913 12.8566 15.5834 12.3607 15.5834C11.6382 15.5834 10.8662 15.4134 10.0516 15.0663C9.23699 14.7192 8.42241 14.2517 7.61491 13.6638C6.80033 13.0688 6.02824 12.4101 5.29158 11.6805C4.56199 10.9438 3.90324 10.1717 3.31533 9.36425C2.73449 8.55675 2.26699 7.74925 1.92699 6.94883C1.58699 6.14133 1.41699 5.36925 1.41699 4.63258C1.41699 4.15091 1.50199 3.6905 1.67199 3.2655C1.84199 2.83341 2.11116 2.43675 2.48658 2.08258C2.93991 1.63633 3.43574 1.41675 3.95991 1.41675C4.15824 1.41675 4.35658 1.45925 4.53366 1.54425C4.71783 1.62925 4.88074 1.75675 5.00824 1.94091L6.65158 4.25716C6.77908 4.43425 6.87116 4.59716 6.93491 4.753C6.99866 4.90175 7.03408 5.0505 7.03408 5.18508C7.03408 5.35508 6.98449 5.52508 6.88533 5.688C6.79324 5.85091 6.65866 6.02091 6.48866 6.19091L5.95033 6.7505C5.87241 6.82841 5.83699 6.9205 5.83699 7.03383C5.83699 7.0905 5.84408 7.14008 5.85824 7.19675C5.87949 7.25341 5.90074 7.29591 5.91491 7.33841C6.04241 7.57216 6.26199 7.87675 6.57366 8.24508C6.89241 8.61341 7.23241 8.98883 7.60074 9.36425C7.98324 9.73967 8.35157 10.0867 8.72699 10.4055C9.09532 10.7172 9.39991 10.9297 9.64074 11.0572C9.67616 11.0713 9.71866 11.0926 9.76824 11.1138C9.82491 11.1351 9.88158 11.1422 9.94532 11.1422C10.0657 11.1422 10.1578 11.0997 10.2357 11.0217L10.7741 10.4905C10.9512 10.3134 11.1212 10.1788 11.2841 10.0938C11.447 9.99466 11.6099 9.94508 11.787 9.94508C11.9216 9.94508 12.0632 9.97341 12.2191 10.0372C12.3749 10.1009 12.5378 10.193 12.7149 10.3134L15.0595 11.978C15.2437 12.1055 15.3712 12.2542 15.4491 12.4313C15.5199 12.6084 15.5624 12.7855 15.5624 12.9838Z" fill="#767676" stroke="#767676" strokeMiterlimit="10"/>
    <path d="M13.1042 6.37492C13.1042 5.94992 12.7713 5.29825 12.2754 4.767C11.8221 4.27825 11.22 3.89575 10.625 3.89575" stroke="#767676" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15.5833 6.37508C15.5833 3.63383 13.3663 1.41675 10.625 1.41675" stroke="#767676" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 20L1.41356 14.8669C0.539637 13.3603 0.0811843 11.654 0.0859598 9.9097C0.0859598 4.44392 4.55587 0 10.043 0C12.7077 0 15.2101 1.03137 17.0869 2.90399C18.9685 4.77662 20.0048 7.26711 20 9.91445C20 15.3802 15.5301 19.8241 10.0382 19.8241H10.0334C8.36676 19.8241 6.72874 19.4059 5.2722 18.6169L0 20ZM5.52531 16.8251L5.82617 17.0057C7.09646 17.7567 8.553 18.1511 10.0382 18.1559H10.043C14.6036 18.1559 18.319 14.4629 18.319 9.9192C18.319 7.71863 17.4594 5.65114 15.8978 4.09221C14.3362 2.53327 12.254 1.67776 10.043 1.67776C5.48233 1.673 1.76695 5.36597 1.76695 9.9097C1.76695 11.4639 2.20153 12.98 3.03247 14.2918L3.22827 14.6055L2.39255 17.6426L5.52531 16.8251Z" fill="white"/>
    <path d="M0.348633 19.6528L1.71444 14.6955C0.869167 13.2459 0.425042 11.5967 0.425042 9.91417C0.429817 4.63851 4.74213 0.34668 10.043 0.34668C12.617 0.34668 15.0287 1.34478 16.8434 3.15086C18.6581 4.95695 19.6562 7.36189 19.6562 9.91892C19.6562 15.1946 15.3391 19.4864 10.043 19.4864H10.0382C8.42885 19.4864 6.84815 19.0824 5.44414 18.322L0.348633 19.6528Z" fill="#5ABF0A"/>
    <path d="M0 20L1.41356 14.8669C0.539637 13.3603 0.0811843 11.654 0.0859598 9.9097C0.0859598 4.44392 4.55587 0 10.043 0C12.7077 0 15.2101 1.03137 17.0869 2.90399C18.9685 4.77662 20.0048 7.26711 20 9.91445C20 15.3802 15.5301 19.8241 10.0382 19.8241H10.0334C8.36676 19.8241 6.72874 19.4059 5.2722 18.6169L0 20ZM5.52531 16.8251L5.82617 17.0057C7.09646 17.7567 8.553 18.1511 10.0382 18.1559H10.043C14.6036 18.1559 18.319 14.4629 18.319 9.9192C18.319 7.71863 17.4594 5.65114 15.8978 4.09221C14.3362 2.53327 12.254 1.67776 10.043 1.67776C5.48233 1.673 1.76695 5.36597 1.76695 9.9097C1.76695 11.4639 2.20153 12.98 3.03247 14.2918L3.22827 14.6055L2.39255 17.6426L5.52531 16.8251Z" fill="url(#paint0_linear_318_9358)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M7.55459 5.76503C7.36835 5.35153 7.17255 5.34203 6.99586 5.33727C6.85259 5.33252 6.68545 5.33252 6.5183 5.33252C6.35116 5.33252 6.08373 5.39431 5.8545 5.64145C5.62527 5.8886 4.98535 6.48746 4.98535 7.70895C4.98535 8.92568 5.87838 10.1044 6.00254 10.2707C6.12671 10.4371 7.72651 13.0179 10.2528 14.0112C12.354 14.8382 12.7838 14.6719 13.2375 14.6291C13.6912 14.5863 14.7084 14.0302 14.9185 13.4504C15.1238 12.8705 15.1238 12.3762 15.0618 12.2717C14.9997 12.1671 14.8325 12.1053 14.5842 11.9818C14.3359 11.8582 13.1133 11.2593 12.8841 11.1738C12.6549 11.093 12.4877 11.0502 12.3254 11.2973C12.1582 11.5445 11.6807 12.1006 11.5374 12.2669C11.3941 12.4333 11.2461 12.4523 10.9978 12.3287C10.7494 12.2051 9.94714 11.9437 8.99681 11.0977C8.2566 10.4418 7.75517 9.6291 7.6119 9.38195C7.46863 9.1348 7.59757 9.00172 7.72174 8.87815C7.83158 8.76883 7.97007 8.58822 8.09423 8.44564C8.2184 8.30305 8.26138 8.19849 8.34256 8.03214C8.42374 7.86579 8.38554 7.7232 8.32346 7.59963C8.26138 7.48081 7.77427 6.25457 7.55459 5.76503Z" fill="white"/>
    <defs>
      <linearGradient id="paint0_linear_318_9358" x1="10.0019" y1="19.9981" x2="10.0019" y2="0" gradientUnits="userSpaceOnUse">
        <stop stopColor="#F9F9F9"/>
        <stop offset="1" stopColor="white"/>
      </linearGradient>
    </defs>
  </svg>
)

const TelegramIcon = () => (
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M1.03117 5.59642C5.05769 3.76182 7.74268 2.55233 9.08611 1.96797C12.9219 0.299503 13.7189 0.00967244 14.2384 0.000102042C14.3527 -0.00200286 14.6082 0.0276103 14.7737 0.168038C14.9134 0.286613 14.9518 0.44679 14.9702 0.559212C14.9886 0.671633 15.0115 0.927733 14.9933 1.12784C14.7855 3.41185 13.8861 8.95453 13.4285 11.5127C13.2349 12.5951 12.8536 12.958 12.4845 12.9936C11.6825 13.0707 11.0734 12.4392 10.2965 11.9066C9.08085 11.0733 8.39409 10.5545 7.21409 9.74133C5.8504 8.80154 6.73442 8.28502 7.51159 7.44087C7.71497 7.21995 11.249 3.8583 11.3174 3.55334C11.326 3.5152 11.3339 3.37304 11.2532 3.29797C11.1724 3.2229 11.0532 3.24857 10.9672 3.26899C10.8453 3.29792 8.90325 4.64029 5.14115 7.29607C4.58991 7.69192 4.09062 7.88479 3.64327 7.87468C3.15011 7.86354 2.20146 7.58307 1.49623 7.34333C0.631245 7.04929 -0.0562297 6.89383 0.00363389 6.39445C0.0348146 6.13434 0.377327 5.86833 1.03117 5.59642Z" fill="#5A91FF"/>
  </svg>
)

// Добавьте этот компонент в начало файла (перед классом PhoneLoginModal)
const ErrorNotification = ({ message, onClose, visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm">
      <div className="bg-white rounded-lg shadow-lg border border-red-100 p-4 flex items-start gap-3">
        <div className="w-5 h-5 rounded-full bg-red-500 flex items-center justify-center flex-shrink-0 mt-0.5">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="white" strokeWidth="0.5"/>
            <path d="M6 4V6.5" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
            <path d="M6 8H6.005" stroke="white" strokeWidth="0.5" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900 mb-1">Ошибка</p>
          <p className="text-sm text-gray-600">{message}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 13L13 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M13 13L1 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

ErrorNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func,
  visible: PropTypes.bool
};

ErrorNotification.defaultProps = {
  message: 'Произошла ошибка',
  visible: false
};

class PhoneLoginModal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      phone: '',
      countryCode: 'ru',
      showCountryDropdown: false,
      step: 1, // 1 - ввод телефона, 2 - выбор способа подтверждения
      formattedPhone: '',
      errorNotification: {
        visible: false,
        message: ''
      },
      resendTimer: 0, // Таймер обратного отсчета в секундах
      canResend: false // Можно ли повторно запросить код
    }
    this.timerInterval = null;
  }

  componentWillUnmount() {
    // Очищаем интервал при размонтировании компонента
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  startResendTimer = () => {
    // Устанавливаем таймер на 45 секунд
    this.setState({ resendTimer: 45, canResend: false });
    
    // Очищаем предыдущий интервал, если он существует
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
    
    // Запускаем новый интервал
    this.timerInterval = setInterval(() => {
      this.setState(prevState => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.timerInterval);
          return { resendTimer: 0, canResend: true };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
  }

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  showErrorNotification = (message) => {
    this.setState({
      errorNotification: {
        visible: true,
        message: message || 'Произошла ошибка'
      }
    });

    // Автоматическое скрытие через 5 секунд
    setTimeout(() => {
      this.hideErrorNotification();
    }, 5000);
  };

  hideErrorNotification = () => {
    this.setState({
      errorNotification: {
        visible: false,
        message: ''
      }
    });
  };

  handlePhoneChange = (value) => {
    this.setState({ phone: value })
  }

  handleSubmit = () => {
    if (this.isPhoneValid()) {
      // Форматируем телефон для отображения
      const formattedPhone = this.state.phone

      this.setState({ 
        step: 2,
        formattedPhone 
      })
    }
  }

  requestTgPhoneStat = () => {
    const main = this

    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'tg_phone'
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      const result = response.data
      if(result.result) {
        window.location.reload()
      } else {
        if(!result.close) {
          setTimeout(function() {
            main.requestTgPhoneStat()
          }, 3000)
        } else {
          main.showErrorNotification(response.data?.massage)
          setTimeout(function() {
            const { step } = main
            if( step == 3 ) main.setState({
              step: 1
            })
          }, 8000)
        }
      }
    })
  }

  handleVerificationMethod = ( method ) => {
    const { phone } = this.state,
    { token } = this.props

    const main = this
    axios.post(`https://${window.location.host}`, {
      content_type: 'application/json',
      action: 'send_code',
      method: method,
      phone: phone,
      token: token
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( method == `telegram`) {
        if(response.data?.result ) {
          this.setState({ 
            step: 3
          }, () => {
            window.open('tg://resolve?domain=pizzaokidoki_bot&start=' + phone.replace(/[^0-9]/g, ''), '_blank')
            setTimeout(function() {
              main.requestTgPhoneStat()
            }, 3000)
          })
        } else main.showErrorNotification(response.data?.massage)
      } else if(response.data?.result) {
        // Запускаем таймер при успешной отправке кода
        this.startResendTimer();
        this.setState({
          step: method == 'whatsapp' ? 5 : 4
        })
      } else main.showErrorNotification(response.data?.massage)
    })
    .catch((error) => {
      main.setState({
        loading: false
      })
      main.showErrorNotification(`Ошибка запроса: ${error}`)
    })
  }

  // Функция для повторной отправки кода
  resendCode = (method) => {
    if (this.state.canResend) {
      this.handleVerificationMethod(method);
    }
  }

  backToPhoneInput = () => {
    this.setState({ step: 1 })
  }

  toggleCountryDropdown = () => {
    this.setState(prevState => ({ showCountryDropdown: !prevState.showCountryDropdown }))
  }

  selectCountry = (code) => {
    this.setState({ 
      countryCode: code,
      showCountryDropdown: false,
      phone: '' // Сбрасываем телефон при смене страны
    })
  }

  isPhoneValid = () => {
    const { phone } = this.state
    const digitsOnly = phone.replace(/\D/g, '')
    return digitsOnly.length > 10 // или нужное вам минимальное количество цифр
  }

  setCode = ( code ) => {
    if(code.length == 4) {
      const { phone } = this.state,
      main = this
      axios.post(`https://${window.location.host}`, {
        content_type: 'application/json',
        action: 'login_code',
        code: code,
        phone: phone
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Request-Source': 'Node.js'
        }
      }).then( ( response ) => {
        if( response.data?.result ) {
          window.location.reload()
        } else main.showErrorNotification(response.data?.massage)
      })
    }
  }

  renderStep1() {
    const { phone, countryCode, showCountryDropdown } = this.state
    const { host } = this.props

    return (
      <>
        {/* Title */}
        <div className="font-manrope text-[24px] font-semibold leading-[25px] tracking-tight text-center text-black mt-[15px] mb-[20px]">
          Укажите номер телефона,<br />чтобы войти в профиль
        </div>

        {/* Phone input */}
        <div className='flex items-center gap-[5px] w-full max-w-[345px] mb-5 relative'>
          <div 
            className='flex items-center gap-[5px] bg-white rounded-full h-10 px-[10px] cursor-pointer flex-none w-[54px]'
            onClick={this.toggleCountryDropdown}
          >
            {countryCode === 'ru' ? (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_318_8807)">
                  <circle cx="10" cy="10" r="10" fill="#D9D9D9"/>
                  <rect x="-6.6665" width="33.3333" height="6.66667" fill="white"/>
                  <rect x="-6.6665" y="6.66626" width="33.3333" height="6.66667" fill="#103FB3"/>
                  <rect x="-6.6665" y="13.3337" width="33.3333" height="6.66667" fill="#E1362D"/>
                </g>
                <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#F6F6F6"/>
                <defs>
                  <clipPath id="clip0_318_8807">
                    <rect width="20" height="20" rx="10" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_by)">
                  <circle cx="10" cy="10" r="10" fill="#D9D9D9"/>
                  <rect x="-6.6665" width="33.3333" height="6.66667" fill="#E1362D"/>
                  <rect x="-6.6665" y="6.66626" width="33.3333" height="6.66667" fill="#0D8038"/>
                  <rect x="-6.6665" y="13.3337" width="33.3333" height="6.66667" fill="white"/>
                  <path d="M-6.6665 0L6.66683 6.66667L-6.6665 13.3333V0Z" fill="#D22730"/>
                  <path d="M-3.3335 4.1665L1.66683 6.6665L-3.3335 9.1665V4.1665Z" fill="white"/>
                </g>
                <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#F6F6F6"/>
                <defs>
                  <clipPath id="clip0_by">
                    <rect width="20" height="20" rx="10" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            )}
            <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 0.5L5.5 5L10 0.5" stroke="black" strokeLinecap="round"/>
            </svg>
          </div>

          {/* Выпадающий список для выбора страны */}
          {showCountryDropdown && (
            <div className="absolute top-12 left-0 z-10 bg-white rounded-lg shadow-lg py-2 min-w-[120px]">
              <div 
                className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => this.selectCountry('ru')}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_318_8807)">
                    <circle cx="10" cy="10" r="10" fill="#D9D9D9"/>
                    <rect x="-6.6665" width="33.3333" height="6.66667" fill="white"/>
                    <rect x="-6.6665" y="6.66626" width="33.3333" height="6.66667" fill="#103FB3"/>
                    <rect x="-6.6665" y="13.3337" width="33.3333" height="6.66667" fill="#E1362D"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_318_8807">
                      <rect width="20" height="20" rx="10" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span className="text-sm">+7</span>
              </div>
              <div 
                className="flex items-center gap-2 px-3 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => this.selectCountry('by')}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_by_small)">
                    <circle cx="10" cy="10" r="10" fill="#D9D9D9"/>
                    <rect x="-6.6665" width="33.3333" height="6.66667" fill="#E1362D"/>
                    <rect x="-6.6665" y="6.66626" width="33.3333" height="6.66667" fill="#0D8038"/>
                    <rect x="-6.6665" y="13.3337" width="33.3333" height="6.66667" fill="white"/>
                    <path d="M-6.6665 0L6.66683 6.66667L-6.6665 13.3333V0Z" fill="#D22730"/>
                    <path d="M-3.3335 4.1665L1.66683 6.6665L-3.3335 9.1665V4.1665Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_by_small">
                      <rect width="20" height="20" rx="10" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <span className="text-sm">+375</span>
              </div>
            </div>
          )}

          <IMaskInput
            mask={countryCode === 'ru' ? "+7 000 000-00-00" : "+375 00 000-00-00"}
            value={phone}
            onAccept={this.handlePhoneChange}
            placeholder={countryCode === 'ru' ? "+7 999 999-99-99" : "+375 29 999-99-99"}
            className="ant-input ant-input-lg flex-1 h-10 rounded-full font-manrope text-[16px] border-0 px-4"
            inputMode="numeric"
            style={{
              height: '40px',
              borderRadius: '20px',
              border: 'none',
              outline: 'none',
              fontFamily: 'Manrope',
              fontSize: '16px'
            }}
          />
        </div>

        {/* Continue button */}
        <button
          onClick={this.handleSubmit}
          disabled={!this.isPhoneValid()}
          className="w-full max-w-[345px] h-10 rounded-full mb-4 text-[14px] font-inter bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
        >
          Продолжить
        </button>

        <div className='font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#666666] mb-5'>
          Или воспользуйтесь Яндекс ID
        </div>
        <div className='flex justify-center mb-2'>
            <a className='w-[200px] block' href={`/yandexid?redirect_uri=https://${host}/yandexid`}>
                <svg
                    width="100%"
                    height="auto"
                    viewBox="0 0 280 56"
                    preserveAspectRatio="xMidYMid meet"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 24C0 12.6863 0 7.02944 3.51472 3.51472C7.02944 0 12.6863 0 24 0H256C267.314 0 272.971 0 276.485 3.51472C280 7.02944 280 12.6863 280 24V32C280 43.3137 280 48.9706 276.485 52.4853C272.971 56 267.314 56 256 56H24C12.6863 56 7.02944 56 3.51472 52.4853C0 48.9706 0 43.3137 0 32V24Z" fill="black" />
                    <rect x="54" y="16" width="24" height="24" rx="12" fill="#FC3F1D" />
                    <path d="M67.6911 35.212H70.1981V20.812H66.5515C62.8841 20.812 60.9572 22.6975 60.9572 25.4739C60.9572 27.6909 62.0139 28.9962 63.8994 30.3429L60.6257 35.212H63.34L66.9866 29.7628L65.7227 28.9133C64.1895 27.8773 63.4436 27.0693 63.4436 25.3288C63.4436 23.7956 64.521 22.7596 66.5722 22.7596H67.6911V35.212Z" fill="white" />
                    <path d="M91.396 21.528H95.3C96.6653 21.528 97.7053 21.7413 98.42 22.168C99.1347 22.5947 99.492 23.3147 99.492 24.328C99.492 24.744 99.4333 25.1067 99.316 25.416C99.1987 25.7147 99.028 25.976 98.804 26.2C98.5907 26.4133 98.3293 26.5893 98.02 26.728C97.7107 26.8667 97.3693 26.9733 96.996 27.048C97.956 27.1653 98.6813 27.4267 99.172 27.832C99.6627 28.2373 99.908 28.856 99.908 29.688C99.908 30.2853 99.7907 30.7973 99.556 31.224C99.3213 31.64 98.996 31.9813 98.58 32.248C98.164 32.504 97.6733 32.696 97.108 32.824C96.5427 32.9413 95.9293 33 95.268 33H91.396V21.528ZM93.332 23.208V26.264H95.396C96.036 26.264 96.5533 26.1307 96.948 25.864C97.3427 25.5867 97.54 25.1547 97.54 24.568C97.54 24.0347 97.3587 23.6773 96.996 23.496C96.644 23.304 96.1427 23.208 95.492 23.208H93.332ZM93.332 27.928V31.336H95.46C95.8227 31.336 96.1533 31.3093 96.452 31.256C96.7507 31.192 97.0067 31.096 97.22 30.968C97.4333 30.8293 97.5987 30.6533 97.716 30.44C97.8333 30.216 97.892 29.944 97.892 29.624C97.892 28.9947 97.684 28.5573 97.268 28.312C96.8627 28.056 96.2067 27.928 95.3 27.928H93.332Z" fill="white" />
                    <path d="M105.273 33.16C104.686 33.16 104.142 33.064 103.641 32.872C103.139 32.68 102.702 32.4027 102.329 32.04C101.966 31.6667 101.678 31.2133 101.465 30.68C101.262 30.1467 101.161 29.5333 101.161 28.84C101.161 28.1467 101.262 27.5333 101.465 27C101.678 26.4667 101.966 26.0187 102.329 25.656C102.702 25.2827 103.139 25.0053 103.641 24.824C104.142 24.632 104.686 24.536 105.273 24.536C105.859 24.536 106.403 24.632 106.905 24.824C107.406 25.0053 107.843 25.2827 108.217 25.656C108.59 26.0187 108.883 26.4667 109.097 27C109.31 27.5333 109.417 28.1467 109.417 28.84C109.417 29.5333 109.31 30.1467 109.097 30.68C108.883 31.2133 108.59 31.6667 108.217 32.04C107.843 32.4027 107.406 32.68 106.905 32.872C106.403 33.064 105.859 33.16 105.273 33.16ZM105.273 31.608C105.913 31.608 106.441 31.384 106.857 30.936C107.283 30.488 107.497 29.7893 107.497 28.84C107.497 27.9013 107.283 27.208 106.857 26.76C106.441 26.3013 105.913 26.072 105.273 26.072C104.643 26.072 104.115 26.3013 103.689 26.76C103.273 27.208 103.065 27.9013 103.065 28.84C103.065 29.7893 103.273 30.488 103.689 30.936C104.115 31.384 104.643 31.608 105.273 31.608Z" fill="white" />
                    <path d="M114.714 23.704C114.266 23.704 113.876 23.6453 113.546 23.528C113.226 23.4107 112.954 23.2507 112.73 23.048C112.516 22.8347 112.356 22.5893 112.25 22.312C112.143 22.024 112.09 21.72 112.09 21.4H113.722C113.722 21.7733 113.807 22.0453 113.978 22.216C114.159 22.376 114.404 22.456 114.714 22.456C115.023 22.456 115.263 22.376 115.434 22.216C115.604 22.0453 115.69 21.7733 115.69 21.4H117.338C117.338 21.72 117.284 22.024 117.178 22.312C117.071 22.5893 116.906 22.8347 116.682 23.048C116.468 23.2507 116.196 23.4107 115.866 23.528C115.535 23.6453 115.151 23.704 114.714 23.704ZM112.81 30.488L116.65 24.696H118.474V33H116.634V27.24L112.826 33H110.97V24.696H112.81V30.488Z" fill="white" />
                    <path d="M124.275 26.2V33H122.419V26.2H119.907V24.696H126.835V26.2H124.275Z" fill="white" />
                    <path d="M130.091 30.488L133.931 24.696H135.755V33H133.915V27.24L130.107 33H128.251V24.696H130.091V30.488Z" fill="white" />
                    <path d="M145.184 33.16C144.512 33.16 143.91 33.064 143.376 32.872C142.843 32.6693 142.39 32.3867 142.016 32.024C141.643 31.6507 141.355 31.1973 141.152 30.664C140.95 30.1307 140.848 29.5227 140.848 28.84C140.848 28.168 140.95 27.5653 141.152 27.032C141.355 26.4987 141.643 26.0507 142.016 25.688C142.39 25.3147 142.848 25.032 143.392 24.84C143.936 24.6373 144.544 24.536 145.216 24.536C145.792 24.536 146.294 24.6 146.72 24.728C147.158 24.856 147.504 25.016 147.76 25.208V26.744C147.43 26.5307 147.067 26.3653 146.672 26.248C146.288 26.1307 145.84 26.072 145.328 26.072C143.611 26.072 142.752 26.9947 142.752 28.84C142.752 30.6853 143.595 31.608 145.28 31.608C145.824 31.608 146.288 31.5493 146.672 31.432C147.067 31.304 147.43 31.144 147.76 30.952V32.488C147.483 32.6693 147.136 32.8293 146.72 32.968C146.304 33.096 145.792 33.16 145.184 33.16Z" fill="white" />
                    <path d="M153.097 25.128C153.097 24.52 153.204 23.992 153.417 23.544C153.631 23.0853 153.929 22.712 154.313 22.424C154.697 22.1253 155.156 21.9013 155.689 21.752C156.233 21.6027 156.836 21.528 157.497 21.528H161.225V33H159.273V28.584H157.497L154.569 33H152.313L155.545 28.296C154.713 28.0933 154.095 27.7253 153.689 27.192C153.295 26.648 153.097 25.96 153.097 25.128ZM159.273 26.968V23.208H157.481C156.756 23.208 156.175 23.352 155.737 23.64C155.311 23.9173 155.097 24.3973 155.097 25.08C155.097 25.752 155.289 26.2373 155.673 26.536C156.057 26.824 156.601 26.968 157.305 26.968H159.273Z" fill="white" />
                    <path d="M168.845 29.496H165.341V33H163.485V24.696H165.341V27.992H168.845V24.696H170.701V33H168.845V29.496Z" fill="white" />
                    <path d="M172.558 31.496C172.803 31.2827 172.995 30.9893 173.134 30.616C173.283 30.2427 173.401 29.7787 173.486 29.224C173.571 28.6587 173.635 28.0027 173.678 27.256C173.721 26.5093 173.758 25.656 173.79 24.696H179.87V31.496H181.118V35.368H179.502L179.358 33H173.63L173.486 35.368H171.854V31.496H172.558ZM178.014 31.496V26.2H175.39C175.337 27.512 175.246 28.6 175.118 29.464C175.001 30.3173 174.803 30.9947 174.526 31.496H178.014Z" fill="white" />
                    <path d="M189.273 32.392C189.156 32.4667 189.012 32.552 188.841 32.648C188.67 32.7333 188.468 32.8133 188.233 32.888C187.998 32.9627 187.726 33.0267 187.417 33.08C187.108 33.1333 186.756 33.16 186.361 33.16C184.836 33.16 183.694 32.7813 182.937 32.024C182.19 31.2667 181.817 30.2053 181.817 28.84C181.817 28.168 181.918 27.5653 182.121 27.032C182.324 26.4987 182.606 26.0507 182.969 25.688C183.332 25.3147 183.764 25.032 184.265 24.84C184.766 24.6373 185.316 24.536 185.913 24.536C186.532 24.536 187.086 24.6373 187.577 24.84C188.078 25.0427 188.489 25.3467 188.809 25.752C189.129 26.1573 189.348 26.6587 189.465 27.256C189.593 27.8533 189.598 28.552 189.481 29.352H183.737C183.812 30.1093 184.062 30.68 184.489 31.064C184.916 31.4373 185.582 31.624 186.489 31.624C187.15 31.624 187.7 31.544 188.137 31.384C188.585 31.2133 188.964 31.0373 189.273 30.856V32.392ZM185.913 26.008C185.369 26.008 184.91 26.1733 184.537 26.504C184.164 26.8347 183.918 27.3253 183.801 27.976H187.705C187.726 27.304 187.577 26.808 187.257 26.488C186.937 26.168 186.489 26.008 185.913 26.008Z" fill="white" />
                    <path d="M193.78 29.624H193.06V33H191.204V24.696H193.06V28.12H193.844L196.484 24.696H198.436L195.3 28.696L198.564 33H196.372L193.78 29.624Z" fill="white" />
                    <path d="M203.231 33.16C202.559 33.16 201.956 33.064 201.423 32.872C200.89 32.6693 200.436 32.3867 200.063 32.024C199.69 31.6507 199.402 31.1973 199.199 30.664C198.996 30.1307 198.895 29.5227 198.895 28.84C198.895 28.168 198.996 27.5653 199.199 27.032C199.402 26.4987 199.69 26.0507 200.063 25.688C200.436 25.3147 200.895 25.032 201.439 24.84C201.983 24.6373 202.591 24.536 203.263 24.536C203.839 24.536 204.34 24.6 204.767 24.728C205.204 24.856 205.551 25.016 205.807 25.208V26.744C205.476 26.5307 205.114 26.3653 204.719 26.248C204.335 26.1307 203.887 26.072 203.375 26.072C201.658 26.072 200.799 26.9947 200.799 28.84C200.799 30.6853 201.642 31.608 203.327 31.608C203.871 31.608 204.335 31.5493 204.719 31.432C205.114 31.304 205.476 31.144 205.807 30.952V32.488C205.53 32.6693 205.183 32.8293 204.767 32.968C204.351 33.096 203.839 33.16 203.231 33.16Z" fill="white" />
                    <path d="M213.16 21.528V33H211.224V21.528H213.16Z" fill="white" />
                    <path d="M215.615 21.528H219.487C220.297 21.528 221.049 21.6187 221.743 21.8C222.447 21.9813 223.055 22.28 223.567 22.696C224.089 23.112 224.495 23.6613 224.783 24.344C225.081 25.0267 225.231 25.8693 225.231 26.872C225.231 27.8853 225.081 28.776 224.783 29.544C224.495 30.3013 224.084 30.936 223.551 31.448C223.028 31.96 222.404 32.3493 221.679 32.616C220.964 32.872 220.18 33 219.327 33H215.615V21.528ZM217.551 23.208V31.336H219.391C219.956 31.336 220.468 31.2507 220.927 31.08C221.396 30.9093 221.796 30.648 222.127 30.296C222.468 29.944 222.729 29.496 222.911 28.952C223.103 28.3973 223.199 27.7413 223.199 26.984C223.199 26.2373 223.108 25.624 222.927 25.144C222.745 24.6533 222.489 24.264 222.159 23.976C221.839 23.688 221.455 23.4907 221.007 23.384C220.559 23.2667 220.073 23.208 219.551 23.208H217.551Z" fill="white" />
                </svg>
            </a>
        </div>
        <div className='flex justify-center mb-5'>
            <a className='w-[200px] block' href={`/yandexid?redirect_uri=https://${host}/vkid`}>
              <svg className='w-full h-auto' width="175" height="36" viewBox="0 0 175 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 8C0 3.58172 3.58172 0 8 0H167C171.418 0 175 3.58172 175 8V28C175 32.4183 171.418 36 167 36H8C3.58172 36 0 32.4183 0 28V8Z" fill="#0077FF"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M28.2653 10.2653C27 11.5306 27 13.5671 27 17.64V18.36C27 22.4329 27 24.4694 28.2653 25.7347C29.5306 27 31.5671 27 35.64 27H36.36C40.4329 27 42.4694 27 43.7347 25.7347C45 24.4694 45 22.4329 45 18.36V17.64C45 13.5671 45 11.5306 43.7347 10.2653C42.4694 9 40.4329 9 36.36 9H35.64C31.5671 9 29.5306 9 28.2653 10.2653Z" fill="white"/>
                <path d="M36.6094 22C32.5557 22 30.0963 19.1823 30 14.5H32.0531C32.1171 17.9395 33.679 19.397 34.8763 19.6967V14.5H36.8439V17.4683C37.9988 17.3401 39.2076 15.9899 39.6139 14.5H41.5505C41.2406 16.3321 39.9246 17.6823 38.9948 18.2392C39.9253 18.6895 41.4225 19.8682 42 22H39.8714C39.4219 20.5749 38.3209 19.4712 36.8446 19.3213V22H36.6094Z" fill="#0077FF"/>
                <path d="M59.0883 18.502H56.5521L56.5385 17.251H58.7533C59.127 17.251 59.4437 17.1963 59.7035 17.0869C59.9678 16.973 60.1684 16.8112 60.3051 16.6016C60.4418 16.3874 60.5102 16.1299 60.5102 15.8291C60.5102 15.4964 60.4464 15.2253 60.3187 15.0156C60.1911 14.806 59.9952 14.6533 59.7309 14.5576C59.4711 14.4619 59.1384 14.4141 58.7328 14.4141H57.0717V23H55.3559V13.0469H58.7328C59.2797 13.0469 59.7673 13.0993 60.1957 13.2041C60.6286 13.3089 60.9955 13.473 61.2963 13.6963C61.6016 13.915 61.8318 14.193 61.9867 14.5303C62.1462 14.8675 62.226 15.2686 62.226 15.7334C62.226 16.1436 62.128 16.5195 61.932 16.8613C61.7361 17.1986 61.4467 17.4743 61.0639 17.6885C60.6811 17.9027 60.2048 18.0303 59.6352 18.0713L59.0883 18.502ZM59.0131 23H56.0121L56.7846 21.6396H59.0131C59.4005 21.6396 59.724 21.5758 59.9838 21.4482C60.2436 21.3161 60.4372 21.1361 60.5648 20.9082C60.697 20.6758 60.7631 20.4046 60.7631 20.0947C60.7631 19.7712 60.7061 19.4909 60.5922 19.2539C60.4783 19.0124 60.2982 18.8278 60.0521 18.7002C59.8061 18.568 59.4848 18.502 59.0883 18.502H57.1605L57.1742 17.251H59.683L60.0727 17.7227C60.6195 17.7409 61.0684 17.8617 61.4193 18.085C61.7748 18.3083 62.0391 18.5977 62.2123 18.9531C62.3855 19.3086 62.4721 19.6914 62.4721 20.1016C62.4721 20.735 62.3331 21.266 62.0551 21.6943C61.7816 22.1227 61.3874 22.4486 60.8725 22.6719C60.3575 22.8906 59.7377 23 59.0131 23ZM63.873 19.3838V19.2266C63.873 18.6934 63.9505 18.1989 64.1055 17.7432C64.2604 17.2829 64.4837 16.8841 64.7754 16.5469C65.0716 16.2051 65.4316 15.9408 65.8555 15.7539C66.2839 15.5625 66.7669 15.4668 67.3047 15.4668C67.847 15.4668 68.3301 15.5625 68.7539 15.7539C69.1823 15.9408 69.5446 16.2051 69.8408 16.5469C70.137 16.8841 70.3626 17.2829 70.5176 17.7432C70.6725 18.1989 70.75 18.6934 70.75 19.2266V19.3838C70.75 19.917 70.6725 20.4115 70.5176 20.8672C70.3626 21.3229 70.137 21.7217 69.8408 22.0635C69.5446 22.4007 69.1846 22.665 68.7607 22.8564C68.3369 23.0433 67.8561 23.1367 67.3184 23.1367C66.776 23.1367 66.2907 23.0433 65.8623 22.8564C65.4385 22.665 65.0784 22.4007 64.7822 22.0635C64.486 21.7217 64.2604 21.3229 64.1055 20.8672C63.9505 20.4115 63.873 19.917 63.873 19.3838ZM65.5205 19.2266V19.3838C65.5205 19.7165 65.5547 20.0309 65.623 20.3271C65.6914 20.6234 65.7985 20.8831 65.9443 21.1064C66.0902 21.3298 66.277 21.5052 66.5049 21.6328C66.7327 21.7604 67.0039 21.8242 67.3184 21.8242C67.6237 21.8242 67.888 21.7604 68.1113 21.6328C68.3392 21.5052 68.526 21.3298 68.6719 21.1064C68.8177 20.8831 68.9248 20.6234 68.9932 20.3271C69.0661 20.0309 69.1025 19.7165 69.1025 19.3838V19.2266C69.1025 18.8984 69.0661 18.5885 68.9932 18.2969C68.9248 18.0007 68.8154 17.7386 68.665 17.5107C68.5192 17.2829 68.3324 17.1051 68.1045 16.9775C67.8812 16.8454 67.6146 16.7793 67.3047 16.7793C66.9948 16.7793 66.7259 16.8454 66.498 16.9775C66.2747 17.1051 66.0902 17.2829 65.9443 17.5107C65.7985 17.7386 65.6914 18.0007 65.623 18.2969C65.5547 18.5885 65.5205 18.8984 65.5205 19.2266ZM73.983 20.5938L76.8883 15.6035H78.5357V23H76.8883V18.0029L73.983 23H72.3355V15.6035H73.983V20.5938ZM76.4508 12.7598H77.6744C77.6744 13.138 77.5833 13.473 77.401 13.7646C77.2232 14.0518 76.968 14.2773 76.6353 14.4414C76.3072 14.6055 75.9153 14.6875 75.4596 14.6875C74.7714 14.6875 74.2268 14.5098 73.8258 14.1543C73.4293 13.7943 73.2311 13.3294 73.2311 12.7598H74.4547C74.4547 13.015 74.5299 13.2406 74.6803 13.4365C74.8352 13.6279 75.095 13.7236 75.4596 13.7236C75.8196 13.7236 76.0748 13.6279 76.2252 13.4365C76.3756 13.2406 76.4508 13.015 76.4508 12.7598ZM83.8605 15.6035V23H82.2062V15.6035H83.8605ZM86.2873 15.6035V16.9023H79.8205V15.6035H86.2873ZM89.24 20.5938L92.1453 15.6035H93.7928V23H92.1453V18.0029L89.24 23H87.5926V15.6035H89.24V20.5938ZM102.344 21.8242C102.613 21.8242 102.854 21.7718 103.068 21.667C103.287 21.5576 103.463 21.4072 103.595 21.2158C103.731 21.0244 103.807 20.8034 103.82 20.5527H105.372C105.363 21.0312 105.222 21.4665 104.948 21.8584C104.675 22.2503 104.312 22.5625 103.861 22.7949C103.41 23.0228 102.911 23.1367 102.364 23.1367C101.799 23.1367 101.307 23.041 100.888 22.8496C100.468 22.6536 100.12 22.3848 99.8418 22.043C99.5638 21.7012 99.3542 21.307 99.2129 20.8604C99.0762 20.4137 99.0078 19.9352 99.0078 19.4248V19.1855C99.0078 18.6751 99.0762 18.1966 99.2129 17.75C99.3542 17.2988 99.5638 16.9023 99.8418 16.5605C100.12 16.2188 100.468 15.9521 100.888 15.7607C101.307 15.5648 101.797 15.4668 102.357 15.4668C102.95 15.4668 103.469 15.5853 103.916 15.8223C104.363 16.0547 104.714 16.3805 104.969 16.7998C105.229 17.2145 105.363 17.6976 105.372 18.249H103.82C103.807 17.9756 103.738 17.7295 103.615 17.5107C103.497 17.2874 103.328 17.1097 103.109 16.9775C102.895 16.8454 102.638 16.7793 102.337 16.7793C102.004 16.7793 101.729 16.8477 101.51 16.9844C101.291 17.1165 101.12 17.2988 100.997 17.5312C100.874 17.7591 100.785 18.0166 100.73 18.3037C100.68 18.5863 100.655 18.8802 100.655 19.1855V19.4248C100.655 19.7301 100.68 20.0264 100.73 20.3135C100.781 20.6006 100.867 20.8581 100.99 21.0859C101.118 21.3092 101.291 21.4893 101.51 21.626C101.729 21.7581 102.007 21.8242 102.344 21.8242ZM113.998 21.1816L116.616 13.0469H118.51L114.942 23H113.663L113.998 21.1816ZM111.578 13.0469L114.176 21.1816L114.531 23H113.246L109.692 13.0469H111.578ZM121.49 13.0469V23H119.774V13.0469H121.49ZM127.471 13.0469L123.438 17.8389L121.141 20.2725L120.841 18.5703L122.481 16.5469L125.38 13.0469H127.471ZM125.626 23L122.351 18.2832L123.534 17.1143L127.663 23H125.626ZM134.238 13.0469V23H132.522V13.0469H134.238ZM139.413 23H137.287L137.3 21.6396H139.413C140.028 21.6396 140.543 21.5052 140.958 21.2363C141.377 20.9674 141.691 20.5824 141.901 20.0811C142.115 19.5798 142.222 18.9827 142.222 18.29V17.75C142.222 17.2122 142.161 16.736 142.038 16.3213C141.919 15.9066 141.741 15.5579 141.504 15.2754C141.272 14.9928 140.985 14.7786 140.643 14.6328C140.306 14.487 139.916 14.4141 139.474 14.4141H137.246V13.0469H139.474C140.135 13.0469 140.739 13.1585 141.286 13.3818C141.833 13.6006 142.304 13.9173 142.701 14.332C143.102 14.7467 143.409 15.2435 143.624 15.8223C143.838 16.401 143.945 17.0482 143.945 17.7637V18.29C143.945 19.0055 143.838 19.6527 143.624 20.2314C143.409 20.8102 143.102 21.307 142.701 21.7217C142.3 22.1318 141.821 22.4486 141.265 22.6719C140.714 22.8906 140.096 23 139.413 23ZM138.237 13.0469V23H136.521V13.0469H138.237Z" fill="white"/>
              </svg>
            </a>
        </div>
      </>
    )
  }

  renderStep2() {
    const { formattedPhone } = this.state

    return (
      <>
        {/* Title */}
        <div className="font-manrope text-[24px] font-semibold leading-[20px] tracking-tight text-center text-black mt-[15px] mb-[10px]">
          Выберите, куда отправить подтверждение?
        </div>

        {/* Phone number */}
        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099] mb-5">
          На номер {formattedPhone}
        </div>

        {/* Verification methods */}
        <div className="w-full max-w-[345px] space-y-3 mb-5">
          {/* Phone call button */}
          <button
            onClick={() => this.handleVerificationMethod('call')}
            className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-white border border-white text-gray-700 flex items-center justify-between gap-2"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center'>
              <PhoneIcon />
            </div>
            Код по звонку
            <div className='w-[30px] h-[30px]'></div>
          </button>
          <div style={{ marginTop: `5px` }} className='text-center text-[12px]'>Пожалуйста, ожидайте входящего звонка от нашего робота. Вам продиктуют код подтверждения.</div>

          {/* WhatsApp button 
          <Button
            size="large"
            onClick={() => this.handleVerificationMethod('whatsapp')}
            className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5ABF0A] border-[#5ABF0A] text-white flex items-center justify-between gap-2"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
              <WhatsAppIcon />
            </div>
            Код в WhatsApp
            <div className='w-[30px] h-[30px]'></div>
          </Button>*/}

          {/* Telegram button 
          <Button
            size="large"
            onClick={() => this.handleVerificationMethod('telegram')}
            className="w-full p-[5px] h-10 rounded-full text-[16px] font-inter bg-[#5A91FF] border-[#5A91FF] text-white flex items-center justify-between gap-2"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
              <TelegramIcon />
            </div>
            Код в Telegram
            <div className='w-[30px] h-[30px]'></div>
          </Button>
          */}
        </div>
      </>
    )
  }

  renderStep3() {
    const { phone } = this.state

    return (
      <>
        {/* Title */}
        <div className="font-manrope text-[24px] font-semibold leading-[20px] tracking-tight text-center text-black mt-[15px] mb-[10px]">
          Вход
        </div>

        {/* Phone number */}
        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099]">
          Запустите telegram бот, чтобы продолжить авторизацию: 
        </div>

        <div className='w-100 flex align-middle justify-center mt-1 text-center mb-5'>
          <a className='underline text-black text-[21px] font-semibold' target="_blank" href={`https://t.me/pizzaokidoki_bot?start=${phone.replace(/[^0-9]/g, '')}`}>@pizzaokidoki_bot</a>
        </div>
      </>
    )
  }

  renderStep4() {
    const { assets_path } = this.props,
    { resendTimer, canResend } = this.state

    return (
      <>
        <div className="font-manrope text-[24px] font-semibold leading-[25px] tracking-tight text-center text-black mt-[15px] mb-[10px]">
          Введите код подтверждения
        </div>

        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099] mb-5">
          {canResend ? (
            <a className='underline' onClick={() => this.resendCode('call')}>Запросить повторно</a>
          ) : (
            `Повторно запросить код можно через: ${this.formatTime(resendTimer)}`
          )}
        </div>

        <div className='mb-3'>
          <input
            id={`code`}
            maxLength={4}
            onChange={( e ) => e.target.value.replace(/\D/g, "").length > 3 && this.setCode( e.target.value.replace(/\D/g, "") )}
            inputMode="numeric"
            autoComplete="one-time-code"
            className='font-mono pl-[20px] ml-[45px] w-[300px] bg-no-repeat h-[69px] border-0 text-[28px] font-[600] text-left tracking-[51px] bg-contain bg-center bg-[unset] outline-none focus:outline-none focus:ring-0 focus:border-none ring-0 border-none'
            style={{ backgroundImage: `url('/${assets_path}/images/code_bg.svg')`, backgroundPosition: `left center` }}
          />
        </div>

        <button
          onClick={this.handleSubmit}
          disabled={true}
          className="w-full max-w-[259px] h-10 rounded-full mb-4 text-[14px] font-inter bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
        >
          Продолжить
        </button>

        {/*
        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099] mb-5">
          Или выберите другой способ получения кода
        </div>

        <div className="w-full max-w-[345px] space-y-3 mb-5">

          <Button
            size="large"
            onClick={() => this.resendCode('whatsapp')}
            className="w-full p-[5px] h-10 rounded-full text-[14px] font-inter bg-[#5ABF0A] border-[#5ABF0A] text-white flex items-center justify-between gap-2 disabled:opacity-50"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
              <WhatsAppIcon />
            </div>
            Код в WhatsApp
            <div className='w-[30px] h-[30px]'></div>
          </Button>

          <Button
            size="large"
            onClick={() => this.resendCode('telegram')}
            className="w-full p-[5px] h-10 rounded-full text-[14px] font-inter bg-[#5A91FF] border-[#5A91FF] text-white flex items-center justify-between gap-2 disabled:opacity-50"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
              <TelegramIcon />
            </div>
            Код в Telegram
            <div className='w-[30px] h-[30px]'></div>
          </Button>
        </div>
        */}
      </>
    )
  }

  renderStep5() {
    const { assets_path } = this.props,
    { resendTimer, canResend } = this.state

    return (
      <>
        <div className="font-manrope text-[24px] font-semibold leading-[25px] tracking-tight text-center text-black mt-[15px] mb-[10px]">
          Введите код подтверждения<br />из приложения WhatsApp
        </div>

        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099] mb-5">
          {canResend ? (
            <a className='underline' onClick={() => this.resendCode('whatsapp')}>Запросить повторно</a>
          ) : (
            `Повторно запросить код можно через: ${this.formatTime(resendTimer)}`
          )}
        </div>

        <div className='mb-3'>
          <input
            id={`code`}
            maxLength={4}
            onChange={( e ) => e.target.value.replace(/\D/g, "").length > 3 && this.setCode( e.target.value.replace(/\D/g, "") )}
            inputMode="numeric"
            autoComplete="one-time-code"
            className='font-mono pl-[20px] ml-[45px] w-[300px] bg-no-repeat h-[69px] border-0 text-[28px] font-[600] text-left tracking-[51px] bg-contain bg-center bg-[unset] outline-none focus:outline-none focus:ring-0 focus:border-none ring-0 border-none'
            style={{ backgroundImage: `url('/${assets_path}/images/code_bg.svg')`, backgroundPosition: `left center` }}
          />
        </div>

        <button
          onClick={this.handleSubmit}
          disabled={true}
          className="w-full max-w-[259px] h-10 rounded-full mb-4 text-[14px] font-inter bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] disabled:opacity-50"
        >
          Продолжить
        </button>

        {/*
        <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#00000099] mb-5">
          Или выберите другой способ получения кода
        </div>

        <div className="w-full max-w-[345px] space-y-3 mb-5">

          <Button
            size="large"
            onClick={() => this.resendCode('call')}
            className="w-full p-[5px] h-10 rounded-full text-[14px] font-inter bg-white border-white text-gray-700 flex items-center justify-between gap-2 disabled:opacity-50"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center'>
              <PhoneIcon />
            </div>
            Код в СМС
            <div className='w-[30px] h-[30px]'></div>
          </Button>

          <Button
            size="large"
            onClick={() => this.resendCode('telegram')}
            className="w-full p-[5px] h-10 rounded-full text-[14px] font-inter bg-[#5A91FF] border-[#5A91FF] text-white flex items-center justify-between gap-2 disabled:opacity-50"
          >
            <div className='w-[30px] h-[30px] rounded-full bg-white flex items-center justify-center'>
              <TelegramIcon />
            </div>
            Код в Telegram
            <div className='w-[30px] h-[30px]'></div>
          </Button>
        </div>
        */}
      </>
    )
  }

  render() {
    const { assets_path, visible, onClose, showFeedbackForm } = this.props
    const { step, errorNotification } = this.state

    if (!visible) return null

    return (
      <>
        <div className="fixed inset-0 z-50 flex items-center justify-center p-0">
          {/* Overlay */}
          <div 
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={onClose}
          />
          
          {/* Modal content */}
          <div 
            className="relative w-full h-full md:w-[400px] md:h-auto md:max-h-[90vh] md:rounded-2xl overflow-hidden flex flex-col"
            style={{
              backgroundImage: `url(/${assets_path}/images/login_bg.svg)`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {/* Header with close button and feedback icon */}
            <div className="flex justify-between items-start p-4">
              {/* Close button */}
              <button
                onClick={step === 1 ? onClose : this.backToPhoneInput}
                className="w-10 h-10 rounded-full bg-white flex items-center justify-center"
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L11 11" stroke="black" strokeLinecap="round"/>
                  <path d="M11 1L1 11" stroke="black" strokeLinecap="round"/>
                </svg>
              </button>

              {/* Feedback icon */}
              <button onClick={() => showFeedbackForm()} className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                <img
                  src={`/${assets_path}/images/feedback_icon.svg`}
                  alt="Feedback"
                  width={20}
                  height={20}
                />
              </button>
            </div>

            {/* Main content */}
            <div className="flex flex-col items-center flex-grow justify-center px-4 pb-4">
              {/* Login image */}
              <img
                src={`/${assets_path}/images/login_image.svg`}
                alt="Login"
                width={92}
                height={92}
              />

              {step === 1 && this.renderStep1()}
              {step === 2 && this.renderStep2()}
              {step === 3 && this.renderStep3()}
              {step === 4 && this.renderStep4()}
              {step === 5 && this.renderStep5()}

              {/* Privacy policy text */}
              <div className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#666666] mb-5">
                При авторизации в профиле, вы соглашаетесь<br />
                с <a className="text-[#000000] underline" href="/politika">Политикой конфиденциальности</a>
              </div>
            </div>

            {/* Support link at bottom */}
            <div className="mt-auto p-4">
              <div onClick={() => showFeedbackForm()} className="font-manrope text-[14px] leading-[100%] tracking-tight text-center text-[#000000] underline">
                Связаться с поддержкой
              </div>
            </div>
          </div>
        </div>
        <ErrorNotification
          visible={errorNotification.visible}
          message={errorNotification.message}
          onClose={this.hideErrorNotification}
        />
      </>
    )
  }
}

PhoneLoginModal.propTypes = {
  assets_path: PropTypes.string.isRequired,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  token: PropTypes.string,
  showFeedbackForm: PropTypes.func,
  host: PropTypes.string
}

PhoneLoginModal.defaultProps = {
  visible: false,
  token: ``,
  // redirect_uri для входа через Яндекс/VK должен указывать на текущий домен, а их теперь два
  host: typeof window !== 'undefined' ? window.location.host : 'pizzaokidoki.ru'
}

export default PhoneLoginModal